import { allowedExtensions } from "../config/globalVar";

// Function to check the file extension against the allowed list
  export const checkFileExtension = (filename) => {
    // Get the file extension
    const extension = filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
    return allowedExtensions.includes(`.${extension.toLowerCase()}`);
  };